const hostsByNodeEnv = {
  production: '',
  development: 'http://int.losberger.local', //'http://localhost:10030',
  test: 'http://int.losberger.local',
};
const host = hostsByNodeEnv[process.env.NODE_ENV];
const networkConf = {
  baseURL: host,
  timeout: 60000,
};
export default networkConf;
